export const HIDE_CAMPAIGN_PROMO = 'HIDE_CAMPAIGN_PROMO';

export const hideCampaignPromo = campaignId => ({
    type: HIDE_CAMPAIGN_PROMO,
    campaignId,
});
